'use strict';

var angular = require('angular');
var _ = require('lodash');
var FaresOptimizerWarningModalController = function FaresOptimizerWarningModalController($timeout, $scope) {
  $scope.handleWarning = function () {
    var modalData = $scope.warningModalData;
    $scope.handleModalHideAndResetItsState();
    $scope.warningCallback(modalData);
  };
  $scope.handleModalHideAndResetItsState = function () {
    $scope.warningMsg = '';
    angular.element('body').removeClass('modal-open');
    angular.element('.modal-backdrop').remove();
  };
};
FaresOptimizerWarningModalController.$inject = ['$timeout', '$scope'];
module.exports = FaresOptimizerWarningModalController;